/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  ShippingAndBilling.tsx
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Sivateja (H267743)
 *
 * @Date         : OCT 9, 2019
 *
 * @Version      : Version 1.0
 *
 *  By           : Sivateja (H267743)
 * On            : Aug 05, 2019
 * Description   : Adding Common component to scroll to Top (ASDS-1477)

 *  By           : Sivateja (H267743)
 * On            :  oct 11, 2019
 * Description   : renamed the component to OnRouteChange (ASDS-1299)
 *
 * By            : H224423
 * On            : NOV 08, 2019
 * Description   : Implemented Order succes - order details with session storage

 * By            : E807958
 * On            : NOV 08 2019
 * Description   : ASDS-1671
 *
 * By            : H422337
 * On            : NOV 22, 2020
 * Description   : Implemented Order succes -remove order details with session storage and store
 *
 ******************************************************************************/

import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { removeItemFromSessionStorage, saveRoute, removeOrderDetails, removeFailureOrderDetails } from '../../../config/sessionStorage';
import RouteConstants from '../constants/route-constants';
import ProductAlertActions from '../redux/actions/products-alerts-action';
import PlaceOrderRequestActions from '../redux/actions/place-order-request-actions';
import ShippingBillingActions from '../redux/actions/shipping-billing-actions';

/* THIS COMPONENT IS TO HANDLE THE ACTIONS THAT THAT NEED TO BE PERFORMED CARE WHILE ROUTE CHANGED*/
class OnRouteChange extends React.Component<any, any> {
    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            // hide Product added notification from Purchase Software Page
            if(this.props.location.pathname === RouteConstants.PURCHASE_SOFTWARE){
                this.props.hideAlert();
            }
            saveRoute(this.props.location.pathname);
            window.scrollTo(0, 0);
            if (this.props.location.pathname === RouteConstants.SHIPPING_BILLING) {
                /* need to clear the session storage if the user is going back to shipping and billing*/
                removeItemFromSessionStorage('shippingBillingData');
            } else if (this.props.location.pathname === RouteConstants.ORDER_SUCCESS) {
                /* need to clear the session storage if the user is going back to shipping and billing*/
                removeItemFromSessionStorage('shippingBillingData');
                // removing orderObj once the the order is placed successfully
                removeItemFromSessionStorage('orderObj');
            }
            else if ((this.props.location.pathname === RouteConstants.PURCHASE_SOFTWARE || this.props.location.pathname === RouteConstants.ORDER_HISTORY)  && prevProps.location.pathname === RouteConstants.ORDER_SUCCESS) {
                removeOrderDetails();
                const failureData = {
                    'results': {
                        'orderId': '',
                        'orderNo': ''
                    },
                    'status': ''
                };
                this.props.removePlaceOrderDetails(failureData);
            }
             else if ((this.props.location.pathname === RouteConstants.PURCHASE_SOFTWARE || this.props.location.pathname === RouteConstants.ORDER_HISTORY) &&  prevProps.location.pathname === RouteConstants.ORDER_FAILURE) {
                  removeFailureOrderDetails();
                  const failureData = {
                    'results': {
                        'orderId': '',
                        'orderNo': ''
                    },
                    'status': ''
                };
                 this.props.removePlaceOrderDetails(failureData);
            }
            else if (prevProps.location.pathname === RouteConstants.SHIPPING_BILLING) {
                if (this.props.creditCardPaymentFailure) {
                    this.props.updateCCPaymentFailure(false);
                   }
            }
        }
    }
    render() {
        return null;
    }
}
function mapStateToProps(state) {
    return {
    creditCardPaymentFailure: state.shippingBillingData.payload.shippingBillingObj.creditCardPaymentFailure
    }
}
const mapDispatchToProps = {
    hideAlert: ProductAlertActions.hideAlert,
    removePlaceOrderDetails: PlaceOrderRequestActions.dispatchPlaceOrderRequest,
    updateCCPaymentFailure: ShippingBillingActions.updateCCPaymentFailure,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OnRouteChange));
